import React, { useEffect, useState } from "react";
import { AiOutlineTable } from "react-icons/ai";
 import { MenuItem } from "@mui/material";
import { TextField } from "@mui/material";
import Sidebar from "../../../Sidebar/Sidebar";
// import { AiFillFile } from "react-icons/ai";
import { BsPencilSquare } from "react-icons/bs";
// import { RiDeleteBinLine } from "react-icons/ri";
// import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {url} from '../../../App'
import "./ViewCollateral.css";
import Cookies from 'js-cookie';

const ViewCollateral = () => {

  const [open, setOpen] = useState(false);
  
  const navigate = useNavigate();

  const [collaterals, setCollaterals] = useState([]);

  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [rowNumber, setRowNumber] = useState(10);
  var [pageCount, setPageCount] = useState(1);

  const [query, setQuery] = useState("");
  
  // const [coApp, setCoApp] = useState("name");
  // const coAppSearchHandler = (e) => setCoApp(e.target.value);

  const [visible, setvisible] = useState(false);
  const [EditCollateralVisible, setEditCollateralVisible] = useState(false);

  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);

  useEffect(() => {

      if (email === "rupesh.bishnoi@credin.in") {
        setvisible(true);
      } else{
      axios
      .post(url + "/user/getsingle", {
        token: token,
        email: email,
        useremail:email
      })
      .then((res) => {
        // console.log(res);
        setEditCollateralVisible(res.data[0].permission.edit_collateral);
      })
      .catch((err) => {
        // console.log(err);
      })};
  
      setOpen(true)
      axios
        .post(url + "/collateral/getall", {
          token: token,
          email: email,
          pageSize: rowNumber,
          page: pageCount
        })
        .then((res) => {
          // console.log(res)
          if(res.data.logout===true){
            setOpen(false)
            setTimeout(() => {
              toast.error(res.data.message);
            navigate("/");
            }, 3000);
          }
          else if (res.data.auth === false) {
            setOpen(false)
            toast.error(res.data.message);
          } else {
            setOpen(false)
            if(res.data.message.length === 0 && pageCount>1) return setPageCount((pageCount)=>pageCount-1);
            setCollaterals(res.data.message);
          }
        })
        .catch((err) => {
          setOpen(false)
          // console.log(err);
        });
      
    }, [token,email,rowNumber,pageCount,navigate]);

  // const handleDeleteCollateral = (collateral_id) => {
  //   let text = "Are you sure you want to delete " + collateral_id + "?";
  //   if (window.confirm(text) === true) {
  //     axios
  //       .post(url+"/collateral/delete", {
  //         token: token,
  //         email: email,
  //         collateral_id: collateral_id,
  //       })
  //       .then((res) => {
  //         // // console.log(res);
  //         toast.success(res.data.message);
  //         axios
  //           .post(url+"/collateral/getall", {
  //             token: token,
  //             email: email,
  //           })
  //           .then((res) => {
  //             // // console.log(res.data);
  //             toast.dismiss("custom");
  //             toast.success("Collaterals Fetched Successfully");
  //             setCollaterals(res.data.reverse());
  //           })
  //           .catch((err) => {
  //             // console.log(err);
  //             toast.dismiss("custom");
  //             toast.error(err.message);
  //           });
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error(err);
  //       });

  //     toast.info("Fetching Details...", {
  //       autoClose: false,
  //       toastId: "custom",
  //     });
  //   }
  // };

  // const handleVerifyCollateral = (collateral_id) => {
  //   let text = "Are you sure you want to Verify " + collateral_id + "?";
  //   if (window.confirm(text) === true) {
  //     axios
  //       .post(url+"/collateral/verified", {
  //         token: token,
  //         email: email,
  //         collateral_id: collateral_id,
  //       })
  //       .then((res) => {
  //         // // console.log(res);
  //         if(res.data.auth === true){
  //           toast.success(res.data.message);
  //         }
  //         else{
  //           toast.error(res.data.message);
  //         }
  //         axios
  //           .post(url+"/collateral/getall", {
  //             token: token,
  //             email: email,
  //           })
  //           .then((res) => {
  //             // // console.log(res.data);
  //             toast.dismiss("custom");
  //             toast.success("Collaterals Fetched Successfully");
  //             setCollaterals(res.data.reverse());
  //           })
  //           .catch((err) => {
  //             // console.log(err);
  //             toast.dismiss("custom");
  //             toast.error(err.message);
  //           });
  //       })
  //       .catch((err) => {
  //         // console.log(err);
  //         toast.error(err);
  //       });

  //     toast.info("Fetching Details...", {
  //       autoClose: false,
  //       toastId: "custom",
  //     });
  //   }
  // };

  const paginationViewHandler = (e) => {
    parseInt(setRowNumber(e.target.value));
  };

  // const [currentPage, setCurrentPage] = useState(0);

  // const handlePageChange = ({ selected }) => {
  //   setCurrentPage(selected);
  // };
  // const itemsPerPage = rowNumber;

  // const pageCount = Math.ceil(collaterals.length / itemsPerPage);

  // const getItemsForPage = (items, page) => {
  //   const startIndex = page * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   return items.slice(startIndex, endIndex);
  // };

  const getPageLoad = (e) => {
    // setOpen(true);
    if(e === "inc"){
      setPageCount((pageCount)=>pageCount+1);
    }else{
      setPageCount((pageCount)=>pageCount-1);
    }
  }

  const serachDateApi = () =>{
    setOpen(true)
    axios
      .post(url + "/collateral/search", {
        token: token,
        email: email,
        borrowerUniqueNo: query
      })
      .then((res) => {
        if (res.data.auth === false) {
          setOpen(false)
          setTimeout(() => {
            window.location.reload();
          }, 3000);
          toast.error(res.data.message);
        } else {
          setOpen(false)
          if(res.data.message.length === 0) return setCollaterals([])
          setCollaterals(res.data.message);
          // console.log(res.data);
        }
      })
      .catch((err) => {
        setOpen(false)
        // console.log(err);
        toast.error(err.message);
      });
  }

  return (
    <>
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} dataSend={"ViewCollateral"} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <AiOutlineTable />
              View Collateral
            </h3>
            <div className="table-collateral-input-fields">
              {/* <div className="table-head-inputs">
                <label>Select Data</label>
                <TextField
                  className="input-field"
                  placeholder="Select Data..."
                  select
                  name="created-data"
                  variant="outlined"
                  value={coApp}
                  size="small"
                  onChange={coAppSearchHandler}
                >
                  <MenuItem value="name">Name</MenuItem>
                  <MenuItem value="mob">Phone Number</MenuItem>
                  <MenuItem value="uniqueno">Unique Number</MenuItem>
                  <MenuItem value="email">E-Mail</MenuItem>
                </TextField>
              </div> */}
              <div className="table-head-inputs">
                {/* <label>Search Data</label> */}
                <TextField
                  placeholder="Collateral Id / Borrower Unique No /Loan Id"
                  name="search-data"
                  id="search-data"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  variant="outlined"
                  size="small"
                />
              </div>
               <button className="digi-kyc" onClick={serachDateApi}>Search</button>
            </div>
            <div className="lms-table-div">
              <table className="lms-table">
                <thead>
                  <tr>
                    <th>Borrower Unique Number</th>
                    <th>Borrower Name</th>
                    <th>Branch Name</th>
                    <th>Collateral Id</th>
                    <th>Loan Id</th>
                    <th>Collateral Type</th>
                    {(EditCollateralVisible || visible) && (
                    <th>Actions</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  
                  {/* {getItemsForPage(collaterals, currentPage)
                    ?.filter((user) =>
                      user.collateral_id?.toLowerCase().includes(query)
                    ) */}
                    {collaterals.length > 0 &&
                    collaterals?.map((collateral, index) => {
                      return (
                    <tr key={index}>
                      <td>{collateral.collateral_borrower_uniqueno}</td>
                      <td className="hover-td" onClick={() => {
                                navigate(`/borrower/detail/${collateral.collateral_loan_id}`);
                                localStorage.setItem(
                                  "uniqueID",
                                  collateral.collateral_borrower_uniqueno
                                )
                              }} style={{wordWrap:"break-word",maxWidth:"150px"}}>{collateral.collateral_borrower_name}</td>
                      <td>{collateral.collateral_branchname}</td>
                      <td>{collateral.collateral_id}</td>
                      <td>{collateral.collateral_loan_id}</td>
                      <td>{collateral.collateral_type}</td>
                      {(EditCollateralVisible || visible) && (
                      <td className="table-btn-col">
                        {/* <button className="table-icon-btn">
                          <AiFillFile />
                        </button> */}
                         {(EditCollateralVisible || visible) && (
                        <Link to="/collateral/edit" state={collateral}>
                        <button className="table-icon-btn" title="Edit">
                          <BsPencilSquare />
                        </button>
                        </Link>
                         )}
                        {/* <button
                          className="table-icon-btn"
                          style={{ color: "red" }}
                          title="Delete"
                          onClick={() =>
                            handleDeleteCollateral(
                              collateral.collateral_id
                            )
                          }
                        >
                          <RiDeleteBinLine />
                        </button> */}
                        {/* <button className="table-cust-btn" onClick={() => handleVerifyCollateral(collateral.collateral_id)}>Verify</button> */}
                      </td>
                      )}
                    </tr>
                  )})}
                </tbody>
              </table>
            </div>
            <div className="pagination-div">
               <div className="pagination-select">
                <label>Entries To Display</label>
                <TextField
                  className=""
                  placeholder="rows"
                  select
                  name="created-data"
                  variant="outlined"
                  value={rowNumber}
                  size="small"
                  onChange={paginationViewHandler}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </TextField>
              </div> 
              <div className="pagination-bar">
                <button className="digi-kyc" style={{marginLeft:"1rem"}} onClick={() => getPageLoad("dec")} disabled={pageCount === 1}>Previous</button>
              </div>
                  <span className="pageCount" style={{ margin: "1rem" }}>{ pageCount }</span>
                  <div className="pagination-bar">
                <button className="digi-kyc" onClick={() => getPageLoad("inc")}>Next</button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      </div>
    </>
  );
};

export default ViewCollateral;
